import { createSelector } from "reselect";
import keyBy from "lodash/keyBy";

const eventTypes = (state) => state.eventLookups.types;
const eventPriorities = (state) => state.eventLookups.priorities;

export const getEventTypesFromEventLookup = createSelector(eventTypes, (types) => {
	return keyBy(types, "id");
});

// selector to get event type or event priority by id. Mainly used in EventCard and EventProfile components.
/*
parameters:
	lookup: "eventType" or "eventPriority"
	id: the id of the event type or event priority
*/
export const getLookupById = createSelector(
	[eventTypes, eventPriorities],
	(types, priorities) => (lookup, id) => {
		if (!lookup || !id) return null;
		switch (lookup) {
			case "eventType": {
				return types.find((item) => item.id === id);
			}
			case "eventPriority": {
				return priorities.find((item) => item.id === id);
			}
			default:
				break;
		}
	}
);